import { useEffect, useState } from 'react'
import MobileDetect from 'mobile-detect'

export default function useMediaQuery() {
  // Start `false` so the first client render matches the server (which always
  // renders `false`), then resolve the real value after mount. Seeding from
  // `window` here would cause a hydration mismatch (React error #425).
  const [ isMobile, setIsMobile ] = useState(false)

  useEffect(() => {
    const onResize = () => {
      const md = new MobileDetect(window.navigator.userAgent)
      setIsMobile(!!md.mobile() || window.innerWidth < 768)
    }
    window.addEventListener('resize', onResize)
    onResize()
    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [])

  return {
    isMobile,
  }
}
